import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=e3fc73f8&scoped=true"
import script from "./StatsTable.vue?vue&type=script&lang=js"
export * from "./StatsTable.vue?vue&type=script&lang=js"
import style0 from "./StatsTable.vue?vue&type=style&index=0&id=e3fc73f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc73f8",
  null
  
)

export default component.exports